import React, { useState } from 'react';
import PreviousPayrollGenerationModal from './PreviousPayrollGenerationModal';
import { Filter } from 'framework/list';

interface ModalState {
  isOpened: boolean;
  data: {
    generationDate: string;
    isChanged: boolean;
  };
  onCloseCallback: (res: boolean) => any;
}

const initialState = {
  data: {
    generationDate: '',
    isChanged: false,
  },
  isOpened: false,
  onCloseCallback: () => {},
};

const usePayrollDataChangesHandler = (getReport: (filters: any) => Promise<any>) => {
  const [modalState, setModalState] = useState<ModalState>(initialState);

  const closeModal = (res: boolean) => {
    modalState.onCloseCallback(res);
    setModalState(initialState);
  };

  const modal = (
    <PreviousPayrollGenerationModal
      isOpened={modalState.isOpened}
      isChanged={modalState.data?.isChanged}
      close={closeModal}
      generationDate={modalState.data?.generationDate}
    />
  );

  const getDataMethod = async (filters: Filter): Promise<Response> => {
    return new Promise(resolve => {
      getReport(filters).then(r => resolve(r));
    });
  };

  return {
    getDataMethod,
    modal,
  };
};

export default usePayrollDataChangesHandler;
